import "./native-app-promo-card.scss";

import { useState } from "react";

import useDesktopChecker from "hooks/useDesktopChecker";

import {
  NATIVE_APP_PROMO_AD_NAME,
  NATIVE_APP_PROMO_APP_STORE_URL,
  NATIVE_APP_PROMO_GOOGLE_PLAY_URL,
} from "utilities/Constant";
import { NativeAppFullStoryProps, trackFSNativeAppAdClicked } from "utilities/full-story";

import NativeAppPromoModal, {
  NativeAppPromoContent,
  useNativeAppPromoState,
} from "components/v2/native-app-promo-modal/NativeAppPromoModal";

interface NativeAppPromoCardProps {
  readonly isModalOpenByDefault?: boolean;
  readonly trackingProps?: NativeAppFullStoryProps;
}

export default function NativeAppPromoCard({
  isModalOpenByDefault = false,
  trackingProps,
}: NativeAppPromoCardProps) {
  const isDesktop = useDesktopChecker();
  const [isModalOpen, setIsModalOpen] = useState(isModalOpenByDefault);
  const { isQrOk, onQrError, shouldShowBadges, onBadgeError } = useNativeAppPromoState();

  const handlePrimaryCtaClick = () => {
    if (isDesktop) {
      setIsModalOpen(true);
      return;
    }

    // On mobile, directly redirect to app store or play store
    const isAndroid = /android/i.test(navigator.userAgent);
    window.open(
      isAndroid
        ? NATIVE_APP_PROMO_GOOGLE_PLAY_URL
        : NATIVE_APP_PROMO_APP_STORE_URL,
      "_blank",
    );
  };

  return (
    <>
      {isModalOpen ? (
        <NativeAppPromoModal
          onClose={() => setIsModalOpen(false)}
          showQr={isQrOk}
          onQrError={onQrError}
          onBadgeError={onBadgeError}
          showAppStoreBadge={shouldShowBadges.appStore}
          showGooglePlayBadge={shouldShowBadges.googlePlay}
          trackingProps={trackingProps}
        />
      ) : (
        <>
          {isDesktop && (
            <h6 className="heading-medium lo-card__label">{NATIVE_APP_PROMO_AD_NAME}</h6>
          )}
          <div className="native-app-promo-card">
            <NativeAppPromoContent
              variant={isDesktop ? "cardDesktop" : "cardMobile"}
              showQr={isQrOk}
              onQrError={onQrError}
              showAppStoreBadge={isDesktop ? shouldShowBadges.appStore : false}
              showGooglePlayBadge={isDesktop ? shouldShowBadges.googlePlay : false}
              onBadgeError={onBadgeError}
              onPrimaryCtaClick={handlePrimaryCtaClick}
              onDownloadBadgeClick={() => trackFSNativeAppAdClicked(trackingProps)}
            />
          </div>
        </>
      )}
    </>
  );
}
